module.exports = function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/Public/Jobs/abound/~/ramda/src/internal/_isRegExp.js
// module id = ../../node_modules/ramda/src/internal/_isRegExp.js
// module chunks = 18